<template>
	<ul v-if="items" class="uk-child-width-1-2@s uk-grid-match homework__list uk-grid-small" uk-grid>
		<HomeworkItem  v-for="(item, k) in items" :date="k" :items="item" :key="k" />
	</ul>
</template>

<script>
  import { mapGetters } from 'vuex'
  import HomeworkItem from "./HomeworkItem";

  export default {
    name: "homework-items",
    inject: ['http'],
    components: {
      HomeworkItem
    },
    computed: {
      ...mapGetters({
        user: 'user',
        items: 'student/homework'
      })
    }
  }
</script>